document.addEventListener('DOMContentLoaded', function() {
    if (typeof ScrollMagic === 'undefined') {
        return;
    }
    
    if (typeof TweenMax === 'undefined') {
        return;
    }
    
    let controller = window.scrollMagicController;
    if (!controller) {
      controller = new ScrollMagic.Controller();
      window.scrollMagicController = controller;
    }
    var digitElements = document.querySelectorAll(".digit");
    
    if (digitElements.length === 0) {
        return;
    }
    
    var originalYValues = [0, 100, 200, 300, 400, 500];
    
    digitElements.forEach(function(element, index) {
        var yValue = originalYValues[index] || 0;
        TweenMax.set(element, {y: yValue + "px"});
    });
    
    var tweens = [];
    digitElements.forEach(function(element, index) {
        var tween = TweenMax.to(element, 1.5, {  
            y: "0px",
            ease: Power2.easeOut,
            delay: index * 0.3  
        });
        tweens.push(tween);
    });
    
    var timeline = new TimelineMax();
    timeline.add(tweens);

    var scene = new ScrollMagic.Scene({
        triggerElement: ".footer", 
        duration: 400, 
        triggerHook: 0.3
    })
    .setTween(timeline)
    .addTo(controller);
});
